import React, { useEffect, useState } from 'react';
import BreadcrumbComponent from '../../../../../components/Breadcrumb';
import { Fieldset } from 'primereact/fieldset';
import { Editor } from 'primereact/editor';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { useLocation, useNavigate } from 'react-router-dom';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import bulletinService from './bulletin-service';
import { useToast } from '../../../../../components/Toast';

const BulletinEdit: React.FC = () => {
    const [clientState, setClientState] = useState<any>(null);
    const navigate = useNavigate();
    const location = useLocation();
    const selectedItem = location.state?.selectedItem;
    const [formData, setFormData] = useState<any>(null);
    const [message, setMessage] = useState('');


    const isEdit = !!selectedItem;
    const { showToast } = useToast();


    useEffect(() => {
        const fetchClientState = async () => {
            try {
                bulletinService.getClientState().then((data) => {
                    setClientState(data);
                });

                if (isEdit) {
                    setFormData({
                        bulletinId: selectedItem.memoId,
                        bulletinTitle: selectedItem.fullDesc,
                        fromDate: new Date(selectedItem.fromDate),
                        toDate: new Date(selectedItem.toDate),
                    });
                } else {
                    setFormData(formData);
                };

            } catch (error) {
                clientState.error.detail = error;
                showToast(clientState.error);
            }
        };

        fetchClientState();
    }, []);

    // useEffect(() => {
    //     console.log("selectedItem.htmlContent:", selectedItem?.htmlContent);
    //     if (selectedItem?.htmlContent) {
    //         setMessage(cleanHtmlContent(selectedItem.htmlContent));
    //     } else {
    //         setMessage("");
    //     }
    // }, [selectedItem]);

    useEffect(() => {
        console.log("Final message content for editor:", message);
    }, [message]);

    useEffect(() => {
        if (isEdit && selectedItem?.htmlContent) {
            // const cleaned = cleanHtmlContent(selectedItem.htmlContent);
            setMessage(selectedItem?.htmlContent);
        }
    }, [isEdit, selectedItem]);

    const cleanHtmlContent = (raw: string) => {
        try {
            // If the string is wrapped in quotes, remove them
            if (raw.startsWith('"') && raw.endsWith('"')) {
                raw = raw.slice(1, -1);
            }

            // Replace escaped quotes (\" → ")
            return raw.replace(/\\"/g, '"');
        } catch (e) {
            return raw;
        }
    };

    // const cleanHtmlContent = (htmlString: string) => {
    //     return htmlString.replace(/^"|"$/g, ""); // Removes extra quotes at start and end
    // };

    const handleChange = (e: any) => {
        const { id, value } = e.target;
        setFormData({
            ...formData,
            [id]: value
        });
    };

    const footerTemplate = () => {

        function submit(): void {

            const currentDate = new Date().toLocaleString("en-US", { timeZone: clientState.timeZone });

            formData.message = message;
            formData.insertBy = clientState.userId;
            formData.insertDate = currentDate;
            formData.updateBy = clientState.userId;
            formData.updateDate = currentDate;
            formData.instCode = clientState.facilityCode;
            formData.branchCode = "001";
            formData.fullDesc = formData.bulletinTitle;
            formData.htmlContent = message;

            console.log(formData);

            bulletinService.create(formData).then((response) => {
                if (response) {
                    showToast(clientState.success);
                    navigate(-1);
                }
            });
        }

        return (
            <>
                {!isEdit && (
                    <Button label="Save" severity='success' icon="pi pi-check" style={{ marginRight: '.5em' }} onClick={submit} />
                )}

                <Button label="Back" severity='info' icon="pi pi-chevron-right" style={{ marginRight: '.5em' }} onClick={() => navigate(-1)} />
            </>
        );
    }
    return (
        <div className="grid">
            <div className='col-12'>
                <div className='card-title'>
                    <h5>Bulletin Form</h5>
                    <BreadcrumbComponent />
                </div>
                <div className='form-title'>

                    <Fieldset legend="Bulletin Information">
                        <div className="p-fluid form-grid grid">
                            <div className="field col-12 md:col-6">
                                <label>Start Date</label>
                                <Calendar
                                    value={formData?.fromDate}
                                    dateFormat="dd MM yy"
                                    showIcon
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            fromDate: e.value as Date,
                                        })
                                    }
                                />
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>End Date</label>
                                <Calendar
                                    value={formData?.toDate}
                                    dateFormat="dd MM yy"
                                    showIcon
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            toDate: e.value as Date,
                                        })
                                    }
                                />
                            </div>
                            <div className="field col-12">
                                <label>Bulletin Title</label>
                                <div className="flex gap-2">
                                    <InputText
                                        id="bulletinTitle"
                                        value={formData?.bulletinTitle || ''}
                                        onChange={handleChange}
                                    />
                                </div>

                            </div>
                        </div>
                    </Fieldset>
                    <br />
                    <Fieldset legend="Message Information">
                        <div className="p-fluid form-grid grid">
                            {!isEdit && (
                                <div className="col-12">
                                    <Editor
                                        value={message}
                                        style={{ height: '320px' }}
                                        onTextChange={(e) => setMessage(e.htmlValue || "")}
                                    />
                                </div>
                            )}

                            {isEdit && (
                                <div className="col-12">
                                    <div
                                        className="text-lg text-gray-800"
                                        dangerouslySetInnerHTML={{ __html: cleanHtmlContent(message) }}
                                    />
                                    {/* <div className="col-12">
                                        <InputText
                                            id="message"
                                            value={message || ''}
                                            onChange={handleChange}
                                        />
                                    </div> */}
                                </div>
                            )}

                        </div>
                    </Fieldset>
                    <br />
                    {/* Toolbar */}
                    <Toolbar end={footerTemplate} />
                </div>
            </div>
        </div>
    );
};

export default BulletinEdit;